import { Component, inject } from '@angular/core';
import { DialogRef, KENDO_DIALOGS } from '@progress/kendo-angular-dialog';
import { TranslationPipe } from '@raptor-fe/services';
import { VehicleSpecModalStore } from './vehicle-spec-modal.store';
import { VehicleSpecItem } from '@raptor-fe/core';

/**
 * Read-only viewer for the vehicle's specifications from the National Supplier. A synchronous data lookup (no
 * punchout, no callback, nothing added to the quote). The data loading lives in {@link VehicleSpecModalStore};
 * this component only starts the load, formats values for display, and closes the dialog.
 */
@Component({
    selector: 'lib-vehicle-spec-modal',
    templateUrl: './vehicle-spec-modal.component.html',
    styleUrl: './vehicle-spec-modal.component.scss',
    imports: [KENDO_DIALOGS, TranslationPipe],
    providers: [VehicleSpecModalStore],
})
export class VehicleSpecModalComponent {
    protected readonly dialogRef = inject(DialogRef);
    protected readonly store = inject(VehicleSpecModalStore);

    /** Called by the opener after the dialog is created to fetch the vehicle's specification categories. */
    loadFor(tenantId: string, branchId: string, vehicleId: string): void {
        this.store.init(tenantId, branchId, vehicleId);
    }

    /** Formats one measured value as either a discrete value or a min-max range, with the unit appended. */
    protected formatItem(item: VehicleSpecItem): string {
        const unit = item.unitOfMeasure ? ` ${item.unitOfMeasure}` : '';
        if (item.value) {
            return `${item.value}${unit}`;
        }
        if (item.minValue && item.maxValue) {
            return `${item.minValue} - ${item.maxValue}${unit}`;
        }
        return `${item.minValue ?? item.maxValue ?? ''}${unit}`.trim();
    }

    protected onClose(): void {
        this.dialogRef.close();
    }
}
